var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OwnerPromtionsView',{attrs:{"is_owner_view":false,"is_in_admin_view":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }